import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import WSChat from 'apps/promo/components/chat/WSChat';
import Popup from 'apps/promo/components/common/Popup/Popup';
import PromoSpinner from 'apps/promo/components/common/promo-spinner/PromoSpinner';
import SnackBar from 'apps/promo/components/common/SnackBar/SnackBar';
import AuthPromoBanner from 'apps/promo/components/utils/AuthPromoBanner';
import MessageBodyService from 'apps/promo/components/utils/MessageBodyService';
import PromoModalWithTimer from 'apps/promo/components/utils/PromoModalWithTimer';
import { useApp } from 'apps/promo/hooks/selectors';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

const shouldForwardContentProp = (prop) => prop !== 'isShowSpinner';

const Content = styled.div.withConfig({ shouldForwardProp: shouldForwardContentProp })`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    pointer-events: ${(props) => (props.isShowSpinner ? 'none' : null)};
    opacity: ${(props) => (props.isShowSpinner ? '0.3' : null)};

    & > form {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    & > div {
        filter: ${(props) => (props.isShowSpinner ? 'blur(2px)' : null)};
    }
`;

const BaseLayoutPromo = ({ children, dataTestId, showPromoBanner = false, loading = false, isShowSpinner = false }) => {
    const { modalComponent, isShowModal, isShowModalWithTimer } = useApp();
    return (
        <>
            {showPromoBanner && <AuthPromoBanner />}
            <Wrapper data-testid={dataTestId}>
                <Content isShowSpinner={isShowSpinner}>
                    <SnackBar />
                    {!loading ? children : null}
                    {isShowModal && modalComponent}
                    {isShowModalWithTimer && <PromoModalWithTimer />}
                    <Popup />
                    <MessageBodyService />
                    <WSChat />
                </Content>
                <PromoSpinner />
            </Wrapper>
        </>
    );
};
BaseLayoutPromo.propTypes = {
    showPromoBanner: PropTypes.bool,
    loading: PropTypes.bool,
    isShowSpinner: PropTypes.bool,
    dataTestId: PropTypes.string,
};

export default BaseLayoutPromo;
